import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { layoutTokens, textStyles } from "@/designTokens";
import theme from "@/theme";

import infoIcon from "../../../../assets/image/settings_v2/info.svg";
import successIcon from "../../../../assets/image/settings_v2/success.svg";

export const useSettingsContentStyles = makeStyles(() => ({
  stack: { display: "flex", flexDirection: "column", gap: layoutTokens.space[24] },
  flow: { display: "flex", flexDirection: "column", flex: 1 },
  heading: {
    ...textStyles["SP/Heading/H2"],
    [theme.breakpoints.up("md")]: textStyles["PC/Heading/H4"],
  },
  description: {
    ...textStyles["SP/Body/Large"],
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: textStyles["PC/Body/Large"],
  },
  note: {
    padding: layoutTokens.space[16],
    backgroundColor: theme.palette.semantic["surface/base"],
    borderRadius: layoutTokens.radius.sm,
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[8],
    overflowWrap: "anywhere",
  },
  noteHeading: { ...textStyles["SP/Heading/H4"] },
  caption: {
    ...textStyles["SP/Body/Small"],
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: textStyles["PC/Body/Small"],
  },
  address: { ...textStyles["SP/Button/M"], overflowWrap: "anywhere" },
  helper: { display: "flex", alignItems: "flex-start", gap: layoutTokens.space[8] },
  info: { flex: "0 0 16px", width: 16, height: 16 },
  successMark: {
    width: 56,
    height: 56,
    backgroundColor: theme.palette.semantic["status/success-bg"],
    borderRadius: layoutTokens.radius.full,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actions: {
    marginTop: "auto",
    paddingTop: layoutTokens.space[32],
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[12],
    "& button": { maxWidth: "100%", [theme.breakpoints.up("md")]: { maxWidth: 360 } },
  },
}));

export const SettingsSuccessMark: React.FC = () => {
  const classes = useSettingsContentStyles();
  return (
    <Box className={classes.successMark} aria-hidden="true">
      <img src={successIcon} alt="" />
    </Box>
  );
};

export const SettingsHelper: React.FC = ({ children }) => {
  const classes = useSettingsContentStyles();
  return (
    <Box className={classes.helper}>
      <img className={classes.info} src={infoIcon} alt="" />
      <Typography component="div" className={classes.caption}>
        {children}
      </Typography>
    </Box>
  );
};

export const SettingsDestination: React.FC<{ label: string; value: string }> = ({ label, value }) => {
  const classes = useSettingsContentStyles();
  return (
    <Box className={classes.note} style={{ gap: 4 }}>
      <Typography className={classes.caption}>{label}</Typography>
      <Typography className={classes.address}>{value}</Typography>
    </Box>
  );
};
